import { CSSProperties, FC, PropsWithChildren } from 'react';

import { styled } from '../../theme';

const AccordionDetailsWrapper = styled('div')<{ style?: CSSProperties }>(({ style = {} }) => ({
    padding: 10,
    ...style,
}));

type Props = PropsWithChildren & {
    style?: CSSProperties;
    id?: string;
};

const AccordionDetails: FC<Props> = ({ children, style }) => (
    <AccordionDetailsWrapper style={style}>{children}</AccordionDetailsWrapper>
);

export default AccordionDetails;
